<template>
  <div id="mainLayout_PA_ID">

    <MenuSuperior 
      titulo="GT" 
      subtitulo="Gestión de audiencias temporal"
      :tituloVinculo="{ activo: true, pathName: 'modulosAudienciasTemporal' }"></MenuSuperior>
    <!-- <MenuIzquierda></MenuIzquierda> -->
    <div class="mainLayout_PA_ID_class">
      <!-- <div v-if="$route.name != 'modulosAudienciasTemporal'">
        <button type="button" @click="irAModulo({ nombrePath: 'modulosAudienciasTemporal' })" class="btn btn-sm btn-light"><i class="fas fa-chevron-circle-left"></i>&nbsp;&nbsp;ir a menú principal</button>
      </div> -->
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>  
  </div>
</template>
<script>
  import MenuSuperior from '@/components/Comunes/MenuSuperior.vue'
  import MenuIzquierda from '@/components/DiasHabiles/Comun/MenuIzquierda.vue'

  export default {
    name: `Plantilla`,
    components: {
      MenuSuperior,
      MenuIzquierda
    },
    methods: {
        irAModulo: function({ nombrePath }) { debugger
            this.$router.push({ name: nombrePath });
        }
    }
  }
</script>


<style scoped>
  .mainLayout_PA_ID_class {
    padding-left: 0;
    padding-right: 0;
    width: 100vw;
    min-height: calc(100vh - 60px);
    /* background-color: #202124; */
    background-color: #202124;
    padding: 4.5em 0em 0 0em;
  }
  #title {
    padding-bottom: 20px;
  }

  #title h2 {
    font-size: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Audiencias/Programacion/Comun/Plantilla.vue